module.exports = __webpack_public_path__ + "img/19.a73f8c02.svg";